/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-commonjs,
  func-names,
  import/no-extraneous-dependencies,
  max-len,
  no-restricted-globals,
  no-script-url,
  no-useless-escape,
  react/no-find-dom-node,
  react/no-string-refs
*/
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import HfReactHelper from 'common/utils/hf-react-helper';
import Button from 'common/components/button';
import classNames from 'classnames';
import setTimeout from 'common/utils/set-timeout';
import baseform from 'common/components/base-form';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import ForgotPasswordModal from './forgot-password-modal';
import GoogleSignInButton from './google-signin-button';
import DropboxSignInButton from './dropbox-signin-button';
import { loadArkoseCdnScript } from './arkose';

const messages = defineMessages({
  placeholderEmail: {
    id: '',
    description: 'input, placeholder, default un-used text for a text field that suggests to user what to do. In this case placeholder for email field',
    defaultMessage: 'Enter your email',
  },
  placeholderPassword: {
    id: '',
    description: 'input, placeholder, default un-used text for a text field that suggests to user what to do. In this case placeholder for password field',
    defaultMessage: 'Enter your password',
  },
});

/**
 * NOTE: This form does not follow the proper way to use
 * React and Symfony Forms, a better example can be found
 * by looking at ForgotPasswordForm
 */
const LogInForm = baseform.createFormClass({

  displayName: 'LogInForm',

  propTypes: {
    header: PropTypes.string,
    buttonText: PropTypes.string,
    googleSignInClientId: PropTypes.string,
    redirectUrl: PropTypes.string,
    onErrorRedirectUrl: PropTypes.string,
    tabOffset: PropTypes.number,
    closeAfterLogin: PropTypes.bool,
    emailAddress: PropTypes.string, // FIXME: Should be refactored to come from loginForm.values (same with errors instead of parsing if from the URL)
    recoverPasswordForm: PropTypes.object.isRequired, // Serialized sfForm
    async: PropTypes.bool,
    hideRememberMe: PropTypes.bool,
    hideGoogleOpenId: PropTypes.bool,
    csrfToken: PropTypes.string.isRequired,
    arkosePublicKey: PropTypes.string,
    arkoseEnabled: PropTypes.bool,
  },

  getDefaultProps() {
    return {
      async: true,
      action: '/account/logIn',
    };
  },

  getInitialState() {
    let emailAddress = this.props.emailAddress;
    const href = decodeURIComponent(location.href);

    let matches = href.match(/email\=([^&]+)/i);
    if (matches && matches.length > 1) {
      emailAddress = matches[1];
    }

    if (!emailAddress) {
      matches = href.match(/login_default_email\=([^&]+)/i);
      if (matches && matches.length > 1) {
        emailAddress = matches[1];
      }
    }

    let redirectUrl = this.props.redirectUrl;
    if (!redirectUrl) {
      matches = href.match(/on_login_redirect_url\=([^&]+)/i);
      if (matches && matches.length > 1) {
        redirectUrl = matches[1];
      }
    }

    return {
      password: '',
      emailAddress,
      isProcessing: false,
      redirectUrl,
      closeAfterLogin: /\?close_after_login\=1|&close_after_login\=1/i.test(href),
      arkoseEnabled: this.props.arkoseEnabled,
      arkoseToken: null,
    };
  },

  loadArkose() {
    loadArkoseCdnScript(this.props.arkosePublicKey, (enforcement) => {
      enforcement.setConfig({
        data: {},
        // language: 'en', // TODO: Translate
        onCompleted: (response) => {
          this.handleArkoseEnforcementCompleted(response);
        },
        onHide: () => {},
        onReady: () => {},
        onReset: () => {},
        onShow: () => {},
        onShown: () => {},
        onSuppress: () => {},
      });
      // Add the enforcement to the state so we can use it later
      this.setState({ arkoseEnforcement: enforcement });
    });
  },

  handleArkoseEnforcementCompleted(response) {
    this.setState({ arkoseToken: response.token });
    // Go back and submit the form
    this.onSubmit();
  },

  componentDidMount() {
    const root = $(ReactDOM.findDOMNode(this));
    const emailInput = root.find('input[name=\'login[email_address]\']');
    const pwdInput = root.find('input[name=\'login[password]\']');
    if (emailInput.length === 1 && !this.state.emailAddress) {
      setTimeout(() => {
        emailInput.focus();
      }, 500);
    } else if (this.state.emailAddress && pwdInput.length === 1) {
      setTimeout(() => {
        pwdInput.focus();
      }, 500);
    }
    if (this.props.arkoseEnabled) {
      this.loadArkose();
    }
  },

  onEmailChange(event) {
    this.setState({
      emailAddress: event.target.value.trim(),
    });
  },

  onPasswordChange(event) {
    this.setState({
      password: event.target.value,
    });
  },

  onSubmit(evt = null) {

    if (evt) {
      evt.preventDefault();
    }

    if (this.props.arkoseEnabled && !this.state.arkoseToken) {
      // First run the enforcement
      return this.state.arkoseEnforcement.run();
    }

    if (this.state.isProcessing === false) {

      // Retrieve the values from the email/password field one more time
      // prior to submit. This fixes an issue where Safari auto-complete
      // would not trigger the on*Change events for these fields.
      const root = ReactDOM.findDOMNode(this);
      const minPasswordLength = HfReactHelper.HfConstants.minPasswordLength;
      const emailAddress = $('#login_email_address_input', root).val();
      const password = $('#login_password_input', root).val();

      this.setState({
        errors: null,
        isProcessing: true,
        emailAddress,
        password,
      });

      if (!HfReactHelper.isValidEmailAddress(emailAddress)) {

        this.setState({
          errors: { named: { email_address: 'Invalid email address' } },
          isProcessing: false,
        });

      } else if (password.length < minPasswordLength) {

        this.setState({
          errors: { named: { password: `Your password must be at least ${minPasswordLength} characters long` } },
          isProcessing: false,
        });

      } else if (!this.props.async) {

        // Inline submit
        $('#login_form', root).submit();

      } else {

        // Async submit
        this.submitAsync(function (resp) {

          this.setState({
            isProcessing: false,
          });

          // Close the login modal
          if (resp.success) {
            $('.m-modal--close', '#login_modal').click();
          }

          // Display notification
          if (resp.notification) {
            hellofaxJS.createNotification({
              text: resp.notification.message,
              class_name: resp.notification.type,
            });
          }

          // Redirect to on_login_redirect_url
          if (resp.success === true && resp.on_login_redirect_url) {
            document.location = resp.on_login_redirect_url;
          }

          // Failure
          if (!resp.success) {

            const hasErrorMsg = (resp.error && resp.error.message);

            if (resp.error.code === 'Z') {
              // Clean up the token we had in the state
              this.setState({
                arkoseToken: null,
                errors: { global: resp.error.message },
              });
              // Is we received an arkose response, rollout was enabled
              // in the middle of the session so let's load the test
              if (!this.state.arkoseEnforcement) {
                this.loadArkose();
              } else {
                // Rerun the test
                this.state.arkoseEnforcement.run();
              }
            } else if (resp.on_error_redirect_url) {
              // Redirect to on_error_redirect_url
              document.location = resp.on_error_redirect_url;
            } else if (hasErrorMsg && !resp.notification_message) {
              // Display error message
              this.setState({
                errors: { global: resp.error.message },
              });
            }

          }

        }, function () {

          // Unexpected error
          this.setState({
            errors: { global: 'An unexpected error occurred' },
            isProcessing: false,
          });

        });

      }
    }
  },

  displayForgotPasswordModal() {

    // Note: version 1.4.4 of jQuery is incompatible with Foundation.
    // In this case we'll want to redirect to / to use the regular login form
    if ($.fn.jquery === '1.4.4') {
      window.location = '/';
      return;
    }

    $(ReactDOM.findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'close');
    const attachPoint = HfReactHelper.getRevealAttachPoint('forgot_password_modal', 'tiny');
    ReactDOM.render(
      <ForgotPasswordModal
        emailAddress={this.state.emailAddress}
        recoverPasswordForm={this.props.recoverPasswordForm}
      ></ForgotPasswordModal>,
      attachPoint,
    );
  },

  render() {
    const { intl } = this.props;
    const tabOffset = parseInt(this.props.tabOffset || 0, 10);
    const rowClassNames = classNames({
      row: true,
      'text-center': true,
    });

    const buttonColumnClassNames = 'columns small-12 l-margin-v-20';
    const formColumnClassNames = `${buttonColumnClassNames} text-left m-login--sign-up`;

    let errors;

    if (this.state.errors) {
      errors = (
        <div className='row'>
          <div className='columns l-margin-b-10 small-10 small-offset-1 text-center m-modal--error'>
            { this.renderErrorText() }
          </div>
        </div>
      );
    }

    let buttonText = this.props.buttonText ? this.props.buttonText : 'LOG IN';
    if (this.props.async && this.state.isProcessing) {
      buttonText = 'PROCESSING...';
    }

    let googleSignIn;
    if (!this.props.hideGoogleOpenId) {
      googleSignIn = (
        <div className={`${buttonColumnClassNames} m-login--modal-google-login`}>
          <div className={'m-login--modal-google-login-border'}>
            <div className={'m-login--modal-google-login-or-image'} />
          </div>
          <GoogleSignInButton
            clientId={this.props.googleSignInClientId}
            redirectUrl={this.props.redirectUrl}
            csrfToken={this.props.csrfToken} />
        </div>
      );
    }

    let rememberMe;
    if (!this.props.hideRememberMe) {
      rememberMe = (
        <div className='l-margin-b-10 small-10 small-offset-1 small-text-left'>
          <div className='m-login--centering-container'>
            <div className='m-login--alignment-wrapper'>
              { this.renderField('should_remember_me', {
                id: 'login[should_remember_me]',
                defaultChecked: 'checked',
                tabIndex: tabOffset + 3,
                className: 'm-login--text-input',
              }) }
              <label htmlFor='login[should_remember_me]'>
                <FormattedMessage
                  id=''
                  description='label, checkbox, after logging in user will be automatically logged off. This checkbox allows being remembered in the system and stay logged in longer'
                  defaultMessage='Remember me' />
              </label>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className='m-login'>
        <form ref='login_form' className='m-login--form' id='login_form' action={this.props.action} method='POST' onSubmit={this.onSubmit}>
          <div className={rowClassNames}>
            <div className='columns small-12'>
              <h3>{ this.props.header }</h3>
            </div>
            {googleSignIn}
            <DropboxSignInButton redirectUrl={this.props.redirectUrl} />
            <div className={formColumnClassNames}>
              <div className='l-margin-b-10 small-10 small-offset-1 text-center'>
                { this.renderField('email_address', {
                  id: 'login_email_address_input',
                  className: 'm-login--text-input',
                  placeholder: intl.formatMessage(messages.placeholderEmail),
                  onChange: this.onEmailChange,
                  tabIndex: tabOffset,
                  value: this.state.emailAddress,
                }) }
              </div>
              <div className='l-margin-b-5 small-10 small-offset-1 text-center'>
                { this.renderField('password', {
                  id: 'login_password_input',
                  className: 'm-login--text-input m-login--login-password',
                  placeholder: intl.formatMessage(messages.placeholderPassword),
                  onChange: this.onPasswordChange,
                  tabIndex: tabOffset + 1,
                }) }
              </div>
              <div className='m-login--forgot-pwd-link l-margin-b-10 small-10 small-offset-1 small-text-left'>
                <div className='m-login--centering-container'>
                  <div className='m-login--alignment-wrapper'>
                    <a href='javascript:;' tabIndex={tabOffset + 2} onClick={this.displayForgotPasswordModal}>
                      <FormattedMessage
                        id=''
                        description='link, authorization, link to credentials resetting process in case user is unable to log in.'
                        defaultMessage='Forgot password?' />
                    </a>
                  </div>
                </div>
              </div>
              { rememberMe }
              { this.renderHiddenFields() }
              { errors }
              <div className={`small-10 small-offset-1 text-center${this.props.isInline ? ' m-login--inline-google-login-button-container' : ' m-login--modal-google-login-button-container'}`}>
                <Button onClick={this.onSubmit}
                  buttonClass={this.props.isInline ? 'm-login--inline-google-login-button' : 'm-login--modal-google-login-button'}
                  buttonText={buttonText}
                  buttonColor='grasshopper'
                  buttonHoverColor='castle-rock'
                  buttonTabIndex={tabOffset + 5} />
              </div>

            </div>
          </div>
          <input type='hidden' name='on_error_redirect_url' value={this.props.onErrorRedirectUrl} />
          <input type='hidden' name='arkose_token' value={this.state.arkoseToken} />
          <input type='hidden' name='close_after_login' value={this.state.closeAfterLogin ? '1' : '0'} />
          <input type='hidden' name='login[redirect_url]' value={this.state.redirectUrl} />
          <input type='hidden' name='async' value={this.props.async ? '1' : '0'} />
        </form>
      </div>
    );
  },
});

module.exports = injectIntl(LogInForm);
